import { FC } from 'react';
import { IconProps } from '../types';

export const Final1Icon: FC<IconProps> = ({ width = 15, height = 15, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.5 0.25C11.5041 0.25 14.75 3.49594 14.75 7.5C14.75 11.5041 11.5041 14.75 7.5 14.75C3.49594 14.75 0.25 11.5041 0.25 7.5C0.25 3.49594 3.49594 0.25 7.5 0.25Z"
        fill="url(#paint0_linear_10168_105305)"
      />
      <path
        d="M7.5 0.25C11.5041 0.25 14.75 3.49594 14.75 7.5C14.75 11.5041 11.5041 14.75 7.5 14.75C3.49594 14.75 0.25 11.5041 0.25 7.5C0.25 3.49594 3.49594 0.25 7.5 0.25Z"
        stroke="#74612D"
        strokeWidth="0.5"
      />
      <path
        d="M4.15191 3.552H7.28391V4.584H5.37591V7.152H7.10391V8.148H5.37591V11.988H4.15191V3.552ZM8.544 3.588H10.44V11.988H9.252V4.608H8.544V3.588Z"
        fill="#4D4119"
      />
      <defs>
        <linearGradient
          id="paint0_linear_10168_105305"
          x1="7.5"
          y1="0"
          x2="7.5"
          y2="15"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E4C875" />
          <stop offset="0.43" stopColor="#EDC754" />
          <stop offset="0.89" stopColor="#FAE195" />
        </linearGradient>
      </defs>
    </svg>
  );
};
